// extracted by mini-css-extract-plugin
module.exports = {"btn":"index_btn__1t7YE","maxwidth":"index_maxwidth__3KYQv"};